import type { LOCATION_SEARCH_TYPE } from '@/types'

export type TypeaheadBadgeKind = 'popular' | 'trending'

export type GetTypeaheadBadgeParams = {
  item: Pick<LOCATION_SEARCH_TYPE, 'type' | 'popular' | 'trending'>
  variant: string | undefined
}

export function getTypeaheadBadge({ item, variant }: GetTypeaheadBadgeParams): TypeaheadBadgeKind | null {
  if (item.type !== 'CITY') return null

  switch (variant?.toUpperCase()) {
    case 'POPULAR':
    case 'POPULAR_OVER_TRENDING':
      return item.popular ? 'popular' : null

    case 'TRENDING':
    case 'TRENDING_OVER_POPULAR':
      return item.trending ? 'trending' : null

    default:
      return null
  }
}
